import React, {useEffect, useState} from 'react';
import {useHistory} from "react-router-dom";
import IconTitleValue from "components/textValue/IconTitleValue";
import getDateString from "components/utils/DateUtility";
import IconTitleButtonRound from "components/buttons/IconTitleButtonRound";
import messages from "res/messages/farsi";
import Urls from "../../../connection/Urls";
import {CircularProgress, Divider} from "@material-ui/core";
import {callApi} from "../../../connection/ClientApi";
import {getAddressSize, getLoadingSize, IsLP_MP, IsLP_MP_SP, IsLP_MP_SP_T} from "my-styles/media/media";
import IconTitleButton from "components/buttons/IconTitleButton";
import queryString from "query-string";

import ICBeforePayment from "res/images/before_payment.png";
import ICColors from "res/images/progress_colors.png";
import ICLogo from "res/images/logo_persian.png";
import ICCalender from "res/images/calendar.png";
import ICAddress from "res/images/address.png";
import ICPayment from "res/images/payment.png";
import ICRole from "res/images/role.png";
import ICError from "res/images/error.png";
import ICPhone from "res/images/phone.png";
import ICUserAccount from 'res/images/user.png';
import ICCircle from 'res/images/circle_gray.png';

export default function BeforePayment(props) {

    const history = useHistory()
    const urlParams = queryString.parse(props.location.search)

    const [isCancelled, setIsCancelled] = useState(false)
    const [orderPayment, setOrderPayment] = useState()
    const [ipgModel, setIpgModel] = useState()
    const [showLoading, setShowLoading] = useState(true)
    const [showError, setShowError] = useState(false)
    const [showButton, setShowButton] = useState(false)
    const [buttonText, setButtonText] = useState()
    const [buttonLink, setButtonLink] = useState()
    const [disabled, setDisabled] = useState(false)
    const [selectedPaymentGateway, setSelectedPaymentGateway] = useState()
    const [message, setMessage] = useState()

    function requestPaymentTransaction() {
        let params = new FormData()
        params.append("refrence_id", urlParams.token)
        callApi(Urls.getPaymentRequestTransaction, params, (data) => {
            if (data) {
                if (data.description === 200 || data.description === 202 || data.description === 203) {
                    window.location.replace(data.backLink)
                } else {
                    requestSendOrderToInternetPayment()
                }
            }
        }, () => {

        }, () => {
            setDisabled(true)
            setShowLoading(true)
        }, () => {

        })
    }

    function requestPaymentInfo() {
        if (urlParams && urlParams.token) {
            let params = new FormData()
            params.append("token", urlParams.token)
            callApi(Urls.getPaymentInfo, params, (data) => {
                if (isCancelled) return

                setOrderPayment(data)
                if (data.paymentGateways.length > 0) {
                    setSelectedPaymentGateway(data.paymentGateways[0])
                }
                setShowError(false)
            }, (data) => {
                setMessage(data.message)
                setShowError(true)
            }, () => {
                setShowLoading(true)
            }, () => {
                setShowLoading(false)
            })
        }
    }

    function requestSendOrderToInternetPayment() {
        let params = new FormData()
        params.append("token", urlParams.token)
        callApi(Urls.sendOrderToInternetPayment, params, (data) => {
            if (data.description === 200) {
                setIpgModel(data.ipgModel)
                document.getElementById("submit").click()
            } else if (data.description === 400) {
                props.onAlert(data.message)
            }
        }, (data) => {
            if (data.buttonText) {
                setButtonText(data.buttonText)
                setButtonLink(data.buttonLink)
                setShowButton(true)
            }
            setMessage(data.message)
            setShowLoading(false)
            setShowError(true)
        }, () => {
            setShowLoading(true)
        }, () => {
            setDisabled(false)
            setShowLoading(false)
        })
    }

    useEffect(() => {
        requestPaymentInfo()

        return () => {
            setIsCancelled(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (<div style={{backgroundColor: "var(--yellow_1)", height: IsLP_MP_SP() ? "80em" : "50em"}}>
        <div className="card" style={{
            height: "85%",
            width: "90%",
            position: "absolute",
            top: "7.5%",
            left: "5%"
        }}>
            {orderPayment && !showLoading && !showError &&
            <div>
                <div className="paddingTopSmall">
                    <img className="clickable appLogo"
                         src={ICLogo} alt=""
                         onClick={() => {
                             props.onNavigate(history, '/')
                         }}/>
                    <div style={{width: IsLP_MP_SP() ? "90%" : "80%"}}>
                        <img className="fullWidth" style={{height: 3}} src={ICColors} alt=""/>
                    </div>
                </div>
                <div style={IsLP_MP_SP() ? {display: "flex"} : {}}>
                    <div className="paddingSmall" style={{width: IsLP_MP() ? "65%" : "100%"}}>
                        <div className="fullWidth" style={IsLP_MP_SP() ? {display: "flex"} : {}}>
                            <div style={{width: IsLP_MP_SP() ? "50%" : "100%"}}>
                                <IconTitleValue
                                    valueClassName={"mediumTextBold"}
                                    icon={<img src={ICCalender} alt="" className="xxSmallIcon marginTopXSmall"/>}
                                    title={messages.deliverDate_1}
                                    value={getDateString(orderPayment.tempOrder.shipping_date) + " " + orderPayment.tempOrder.date_added_time}/>
                            </div>
                            <div style={{width: IsLP_MP_SP() ? "50%" : "100%"}}>
                                <IconTitleValue
                                    valueClassName={"mediumTextBold"}
                                    icon={<img src={ICRole} alt="" className="xxSmallIcon marginTopXSmall"/>}
                                    title={messages.productCount}
                                    value={orderPayment.tempOrder.products.length + " " + messages.number}/>
                            </div>
                        </div>
                        <div className="fullWidth" style={IsLP_MP_SP() ? {display: "flex"} : {}}>
                            <div style={{width: IsLP_MP_SP() ? "50%" : "100%"}}>
                                <IconTitleValue
                                    valueClassName={"mediumTextBold"}
                                    icon={<img src={ICUserAccount} alt="" className="xxSmallIcon marginTopXSmall"/>}
                                    title={messages.deliverTakeName}
                                    value={orderPayment.tempOrder.address_full_name}/>
                            </div>
                            <div style={{width: IsLP_MP_SP() ? "50%" : "100%"}}>
                                <IconTitleValue
                                    valueClassName={"mediumTextBold"}
                                    icon={<img src={ICPhone} alt="" className="xxSmallIcon marginTopXSmall"/>}
                                    title={messages.deliverTakePhone}
                                    value={orderPayment.tempOrder.telephone}/>
                            </div>
                        </div>
                        <div className="fullWidth">
                            <IconTitleValue
                                maxLength={getAddressSize()}
                                valueClassName={"mediumTextBold singleLine"}
                                icon={<img src={ICAddress} alt="" className="xxSmallIcon marginTopXSmall"/>}
                                title={messages.address}
                                value={orderPayment.tempOrder.address_address}/>
                        </div>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}}/>
                        <div className={IsLP_MP_SP() ? "marginSmall side_scroll" : "side_scroll"}
                             style={{
                                 maxHeight: IsLP_MP_SP() ? "25%" : "100px",
                                 minHeight: IsLP_MP_SP() ? "20%" : "50px"
                             }}>
                            <div style={{direction: "rtl"}}>
                                {orderPayment.tempOrder.products.map((product, index) => {
                                    return <IconTitleValue
                                        key={index}
                                        titleClassName={"mediumTextBold singleLine"}
                                        valueClassName={"mediumTextBold singleLine"}
                                        icon={<img src={ICCircle} className="xxxxSmallIcon marginTopXSmall"
                                                   alt=""/>}
                                        title={IsLP_MP_SP_T() ? product.name : product.name.length > getAddressSize() ? product.name.substring(0, getAddressSize()) : product.name}
                                        value={parseFloat(product.total).toLocaleString() + " " + messages.priceUnit}/>
                                })}
                            </div>
                        </div>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}}/>
                        <div className="fullWidth">
                            <div style={{width: "100%", marginTop: 5}}>
                                <IconTitleValue
                                    titleClassName="xLargeTextBold"
                                    valueClassName="xLargeTextBold"
                                    icon={<img src={ICPayment} alt="" className="xxSmallIcon  marginTopXSmall"/>}
                                    title={messages.priceNetTotal}
                                    value={parseFloat(orderPayment.tempOrder.net_total).toLocaleString() + " " + messages.priceUnit}/>
                            </div>
                            <div className={IsLP_MP_SP() ? "horizontalFullScreen" : ""}>
                                {orderPayment.paymentGateways &&
                                <div className="horizontalFullScreen">
                                    {orderPayment.paymentGateways.map((paymentGateway, index) => {
                                        return <div
                                            key={index}
                                            className={(selectedPaymentGateway && selectedPaymentGateway.id === paymentGateway.id) ?
                                                "marginSmall border_green" : "marginSmall border_white"} >
                                            <IconTitleButton
                                                fontSize="smallTextBold"
                                                isvertical={"true"}
                                                icon={<img className="smallIcon" src={paymentGateway.image} alt=""/>}
                                                title={paymentGateway.title}
                                                onClick={() => {
                                                    setSelectedPaymentGateway(paymentGateway)
                                                }}/>
                                        </div>
                                    })
                                    }
                                </div>
                                }
                                <div className={IsLP_MP_SP() ? "marginTopMedium" : "toLeft marginLeftSmall "}
                                     style={{display: "flex"}}>
                                    <div className="marginSmall">
                                        <IconTitleButtonRound
                                            backgroundcolor={"var(--red_4)"}
                                            height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                                            width={IsLP_MP_SP_T() ? "100px" : "100px"}
                                            fontSize="largeText"
                                            onClick={() => {
                                                window.location.replace(orderPayment.cancelLink)
                                            }}
                                            title={messages.cancel}/>
                                    </div>
                                    <div className="marginSmall">
                                        <IconTitleButtonRound
                                            disabled={disabled}
                                            backgroundcolor={"var(--blue_3)"}
                                            height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                                            fontSize="largeText"
                                            width={IsLP_MP_SP_T() ? "150px" : "120px"}
                                            onClick={() => {
                                                requestPaymentTransaction()
                                            }}
                                            title={messages.pay}/>
                                        {ipgModel &&
                                        <form style={{display: "none"}} method="post"
                                              action={ipgModel.link}
                                              encType="multipart/form-data">
                                            <input value={ipgModel.tokenIdentity} name="tokenIdentity"/>
                                            <button type="submit" id="submit">Launch</button>
                                        </form>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Divider style={IsLP_MP_SP() ? {} : {width: "93%"}}/>
                    </div>
                    {IsLP_MP() &&
                    <div style={{width: "35%"}}>
                        <img className="toLeft fullWidth" src={ICBeforePayment} alt=""/>
                    </div>
                    }
                </div>
            </div>
            }
            {showLoading &&
            <div className="center" style={{marginTop: "22%"}}>
                <div>
                    <CircularProgress size={getLoadingSize()}/>
                </div>
                <div className="largeTextBold marginTopMedium">
                    {messages.watingForPaymentInfo}
                </div>
            </div>
            }
            {showError && !showLoading &&
            <div className="center" style={{marginTop: "18%"}}>
                <div>
                    <img alt="" src={ICError} className="xxLargeIcon"/>
                </div>
                <div className="largeTextBold marginLarge">
                    {message}
                </div>
                {showButton &&
                <div className="marginSmall">
                    <IconTitleButtonRound
                        backgroundcolor={"var(--blue_3)"}
                        height={IsLP_MP_SP() ? "2.8em" : "2.5em"}
                        fontSize="largeText"
                        width={IsLP_MP_SP() ? "300px" : "250px"}
                        onClick={() => {
                            window.location.replace(buttonLink)
                        }}
                        title={buttonText}/>
                </div>
                }
            </div>
            }
        </div>
    </div>)

}